import Swiper from 'swiper';
import SwiperCore, { Autoplay, Pagination, EffectFade, Navigation } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Autoplay, Pagination, EffectFade, Navigation]);

const setActiveBG = function(type, index) {
	index = (index > 0) ? index - 1 : 0 //reset to zero-index
	switch (type) {
		case 'sector':
			let sectorBGs = document.querySelectorAll('.sector-bg')
			let secIndex = (index == sectorBGs.length)? 0 : index // end of array, reset to zero
			sectorBGs.forEach(element => element.classList.remove('active'))
			sectorBGs[secIndex].classList.add('active')
			break;
		case 'service':
			let serviceBGs = document.querySelectorAll('.service-bg')
			let servIndex = (index == serviceBGs.length) ? 0 : index // end of array, reset to zero
			serviceBGs.forEach(element => element.classList.remove('active'))
			serviceBGs[servIndex].classList.add('active')
			break;
	}
}

// import { gsap } from "gsap";
const sectorSwiper = function (barba) {
	const sectorBackgrounds = document.querySelectorAll('.sector-backgrounds')[0]

	const speed = 2000
	const swiper = new Swiper('.sector-slides', {
		loop: true, 
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 7500,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
		on: {
			activeIndexChange: function (swiper) {
				setActiveBG('sector', swiper.activeIndex);
			},
		},
	})
}

const serviceSwiper = function (barba) {
	const serviceBackgrounds = document.querySelectorAll('.service-backgrounds')[0]

	const speed = 2000
	const swiper = new Swiper('.service-slides', {
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 7500,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
		on: {
			activeIndexChange: function (swiper) {
				setActiveBG('service', swiper.activeIndex);
			},
		},
	})
}

export { sectorSwiper, serviceSwiper }